import React, { useEffect, useState } from "react";
import { useGetLoyaltyUsersByPhoneNumberLazyQuery } from "../../hooks/useGetLoyaltyUsersByPhoneNumberLazyQuery";
import { ELOYALTY_ACTION, EOrderType, IGET_LOYALTY_USER_BY_PHONE_NUMBER_EMAIL } from "../../graphql/customQueries";
import { useUser } from "../../context/user-context";

import "./rewards.scss";
import { useGetLoyaltyUsersByEmailLazyQuery } from "../../hooks/useGetLoyaltyUsersByEmailLazyQuery";
import { restaurantDataList } from "./restaurantList";
import { useRestaurant } from "../../context/restaurant-context";
import { Button } from "../../tabin/components/button";
import { useCart } from "../../context/cart-context";
import { useGetPromotionLazyQuery } from "../../hooks/useGetPromotionLazyQuery";
import { convertCentsToDollars } from "../../util/util";
import { CheckIfPromotionValidResponse } from "../../model/model";
import { toast } from "../../tabin/components/toast";
import { useGetPromotionByIdLazyQuery } from "../../hooks/useGetPromotionByIdLazyQuery";
import { useNavigate } from "react-router";

interface IUserLoyalty {
    [key: string]: {
        restaurantName: string;
        points: number;
    };
}

export const Rewards = () => {
    const [loyaltyPoints, setLoyaltyPoints] = useState(0);
    const { user } = useUser();
    // const { restaurant } = useRestaurant();

    // const { setUserAppliedPromotion, orderType, total } = useCart();

    // const [promotionCode, setPromotionCode] = useState("");
    // const [error, setError] = useState("");

    const { getLoyaltyUsersByPhoneNumberLazyQuery } = useGetLoyaltyUsersByPhoneNumberLazyQuery(user ? user.phoneNumber : "");
    const { getLoyaltyUsersByEmailLazyQuery } = useGetLoyaltyUsersByEmailLazyQuery(user ? user.email : "");

    useEffect(() => {
        onSearchLoyaltyHistory();
    }, []);

    // const {
    //     getPromotionsById,
    //     data: getPromotionsByIdData,
    //     error: getPromotionsByIdError,
    //     loading: getPromotionsByIdLoading,
    // } = useGetPromotionByIdLazyQuery();
    // const navigate = useNavigate();

    // console.log("xxx...getPromotionsByIdData", getPromotionsByIdData);

    // useEffect(() => {
    //     console.log("xxx...I AM HERE!222");

    //     if (getPromotionsByIdError) {
    //         setError("Could not apply discount code. Please try again later");
    //         return;
    //     }

    //     console.log("xxx...I AM HERE!333", getPromotionsByIdData);

    //     if (getPromotionsByIdData) {
    //         console.log("Got getPromotionsByIdData", getPromotionsByIdData);

    //         if (getPromotionsByIdData.length == 0) {
    //             setError("Invalid promo code applied");
    //             return;
    //         } else {
    //             const appliedPromotion = getPromotionsByIdData[0];

    //             if (!orderType || !appliedPromotion.availableOrderTypes) {
    //                 setError("Invalid order type");
    //                 return;
    //             }

    //             if (!appliedPromotion.availableOrderTypes.includes(EOrderType[orderType])) {
    //                 setError(`This code is not valid for ${orderType.toLowerCase()}. Please try another code`);
    //                 return;
    //             }

    //             if (total < appliedPromotion.minSpend) {
    //                 setError(`Minimum spend for this promotion is $${convertCentsToDollars(appliedPromotion.minSpend)}`);
    //                 return;
    //             }

    //             const status = setUserAppliedPromotion(appliedPromotion); //Apply the first one if there are many with the same code.

    //             if (status == CheckIfPromotionValidResponse.UNAVAILABLE) {
    //                 setError("This code is currently unavailable. Please try again later");
    //             } else if (status == CheckIfPromotionValidResponse.EXPIRED) {
    //                 setError("This code is expired. Please try another code");
    //             } else if (status == CheckIfPromotionValidResponse.INVALID_PLATFORM) {
    //                 const platform = process.env.REACT_APP_PLATFORM;

    //                 if (platform) {
    //                     setError(`This code is not valid for ${platform.toLowerCase()}. Please try another code`);
    //                 } else {
    //                     setError(`This code is not valid for this platform. Please try another code`);
    //                 }
    //             } else {
    //                 toast.success("Your loyalty has been applied!");
    //                 navigate(-1);
    //             }
    //         }
    //     }
    // }, [getPromotionsByIdData, getPromotionsByIdError]);

    const onSearchLoyaltyHistory = async () => {
        if (!user) return;

        let loyaltyUserRes: IGET_LOYALTY_USER_BY_PHONE_NUMBER_EMAIL | null = null;

        console.log("xxx...user", user);

        const resPhoneNumber = await getLoyaltyUsersByPhoneNumberLazyQuery({
            variables: {
                phoneNumber: user.phoneNumber,
            },
        });

        if (resPhoneNumber.data && resPhoneNumber.data.listLoyaltyUser.items.length > 0) {
            loyaltyUserRes = resPhoneNumber.data.listLoyaltyUser.items[0];
        }

        if (!loyaltyUserRes) {
            const resEmail = await getLoyaltyUsersByEmailLazyQuery({
                variables: {
                    email: user.email,
                },
            });

            if (resEmail.data && resEmail.data.listLoyaltyUser.items.length > 0) {
                loyaltyUserRes = resEmail.data.listLoyaltyUser.items[0];
            }
        }

        console.log("xxx...loyaltyUserRes", loyaltyUserRes);

        if (loyaltyUserRes) {
            const userLoyaltyRes: IUserLoyalty = {};

            loyaltyUserRes.loyaltyHistories.items.forEach((history) => {
                if (userLoyaltyRes[history.loyaltyRestaurant.id]) {
                    if (history.action === ELOYALTY_ACTION.EARN) {
                        userLoyaltyRes[history.loyaltyRestaurant.id] = {
                            restaurantName: history.loyaltyRestaurant.name,
                            points: userLoyaltyRes[history.loyaltyRestaurant.id].points + history.points,
                        };
                    } else if (history.action === ELOYALTY_ACTION.REDEEM) {
                        userLoyaltyRes[history.loyaltyRestaurant.id] = {
                            restaurantName: history.loyaltyRestaurant.name,
                            points: userLoyaltyRes[history.loyaltyRestaurant.id].points - history.points,
                        };
                    }
                } else {
                    if (history.action === ELOYALTY_ACTION.EARN) {
                        userLoyaltyRes[history.loyaltyRestaurant.id] = {
                            restaurantName: history.loyaltyRestaurant.name,
                            points: history.points,
                        };
                    } else if (history.action === ELOYALTY_ACTION.REDEEM) {
                        userLoyaltyRes[history.loyaltyRestaurant.id] = {
                            restaurantName: history.loyaltyRestaurant.name,
                            points: 0 - history.points,
                        };
                    }
                }
            });

            console.log("xxx...userLoyaltyRes...", userLoyaltyRes);

            let totalPoints = 0;

            restaurantDataList.forEach((restaurantData) => {
                if (userLoyaltyRes[restaurantData.id] && userLoyaltyRes[restaurantData.id].points) {
                    totalPoints += userLoyaltyRes[restaurantData.id].points;
                }
            });

            setLoyaltyPoints(totalPoints);
        } else {
            setLoyaltyPoints(0);
        }
    };

    // const onApplyLoyaltyReward = (rewardPromotionId: string) => {
    //     console.log("xxx...I AM HERE!", rewardPromotionId);
    //     getPromotionsById({
    //         variables: {
    //             id: rewardPromotionId,
    //         },
    //     });
    // };

    return (
        <div className="rewards-card">
            <div className="h2">BUY 10 BURGERS, GET 1 FREE</div>
            <div className="rewards-grid">
                {Array.from({ length: 10 }).map((_, index) => (
                    <div key={index} className={`reward ${index < loyaltyPoints ? "filled" : ""}`}>
                        {index < loyaltyPoints ? (
                            <img
                                src="https://d1hfsnuz4i23pd.cloudfront.net/public/2024-08-28_04:43:25.348-BB%20Logo%20Red.webp"
                                alt="Reward Logo"
                                className="reward-img"
                            />
                        ) : (
                            ""
                        )}
                    </div>
                ))}
            </div>
            <div className="mb-2 mt-4">
                You have {loyaltyPoints} point{loyaltyPoints !== 1 ? "s" : ""}
            </div>
            <div>Earn a free burger of your choice when complete earning 10 Better Burger stamps.</div>
            {/* <div className="h2 mt-4 mb-2">Rewards</div>
            {restaurant &&
                restaurant.loyalties &&
                restaurant.loyalties.items.map((loyalty) => (
                    <>
                        {loyalty.rewards.map((reward) => (
                            <div key={reward.promotionId} className="reward-promotion mb-2">
                                <div className="reward-promotion-name">
                                    {restaurant.promotions.items.find((item) => item.id === reward.promotionId)?.name}
                                </div>
                                <div>
                                    {reward.points} point{reward.points !== 1 ? "s" : ""}
                                </div>
                                <Button disabled={loyaltyPoints < reward.points} onClick={() => onApplyLoyaltyReward(reward.promotionId)}>
                                    Apply
                                </Button>
                            </div>
                        ))}
                    </>
                ))} */}
        </div>
    );
};
